const warnedMethods = new Set<string>();

export function warnOnce(methodName: string, message: string) {
  if (!warnedMethods.has(methodName)) {
    console.warn(message);
    warnedMethods.add(methodName);
  }
}
